<template>
  <div>
    <el-button
      @click="openDialog = !openDialog"
      size="small"
      style="width: 100%; margin-bottom: 2px"
    >
      План по численности
    </el-button>
    <el-dialog
      v-loading="loading"
      title="Добавление перечня профессий"
      :visible.sync="openDialog"
    >

      <el-button size="small" style="width: 100%" type="primary" @click="isSelect = true">+ Выбрать профессию
      </el-button>
      <div class="jobs-ul">
        <div class="jobs-li" v-for="(lw, index) in listWorks" :key="lw.id + index">
          <div style="display: flex; flex: 1">
            <div style="width: 30px">
              <Volumes :table="lw.volumes" @save="(e) => saveVolumes(e, index)"></Volumes>
            </div>
            <strong>{{ lw.name }}</strong>
          </div>
          <i @click="removeFromList" class="el-icon-close"></i>

        </div>
      </div>
      <div style="margin-top: 12px">
        <strong style="margin-top: 12px">Итого: {{ total }}</strong>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="openDialog = false">Отменить</el-button>
        <el-button type="primary" @click="saveAll">Сохранить</el-button>
      </span>
    </el-dialog>

    <el-dialog title="Выбрать профессию" :visible.sync="isSelect" append-to-body
               width="460px">
      <div class="jobs-ul">
        <div
          class="jobs-li" v-for="(job, index) in list" :key="index" @click="add(job)"
        >
          <span>{{ job.name }}</span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import firebase from "firebase";
import Volumes from "./Volumes";

export default {
  name: "VolumesWorksJob",
  components: {Volumes},
  data() {
    return {
      openDialog: false,
      isSelect: false,
      loading: false,
      list: [],
      listWorks: [],
    }
  },
  computed:{
    total() {
      let  result = 0

       this.listWorks.forEach((l) => {
         result += l.total
      })


      return result
    }
  },
  mounted() {
    myFirestore
      .collection('projects')
      .doc(this.$store.state.project.id).collection('jobs')
      .where('type', '==', 'PROF').get()
      .then((data) => {
        const result = []
        data.forEach((subDoc) => {
          const data = subDoc.data()
          result.push({
            name: data.name,
            plan: data.plan,
            id: subDoc.id,
            total: 0,
            volumes: [],
            _data: data
          })
        })

        this.list = result;
      });

    myFirestore
      .collection('projects')
      .doc(this.$store.state.project.id).collection('company_plan')
      .doc(this.$route.params.id).get()
      .then((data) => {
        if(data && data.data() && (data.data()).listWorks) {
          this.listWorks = (data.data()).listWorks
        }
      });
  },
  methods: {
    saveVolumes(e, index) {
      this.listWorks[index].volumes = e.table
      this.listWorks[index].total = e.total
      this.listWorks = [...this.listWorks]
    },
    add(job) {
      this.listWorks.push(job)
      this.listWorks = [...this.listWorks]
      this.isSelect = false
    },
    async saveAll() {
      this.loading = true
      await myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id).collection('company_plan')
        .doc(this.$route.params.id).set({
        listWorks: this.listWorks
      })
      this.$notify.success({
        offset: 60,
        title: 'Успешно',
        message: 'План сохранен',
      });

      this.loading = false
      this.openDialog = false

    },
    removeFromList(index) {
      this.listWorks.splice(index, 1)
      this.listWorks = [...this.listWorks]
    }
  }
}
</script>

<style scoped lang="scss">
.jobs-ul {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 8px;
}

.jobs-li {
  padding: 4px 10px !important;
  width: calc(100% - 20px);
  justify-content: flex-start;
  text-align: left;
  height: auto !important;
  min-height: 48px !important;
  display: flex;
  align-items: center;
  cursor: pointer;
  border-bottom: 1px solid rgba(0, 0, 0, 0.18);

  span {
    text-align: left;
  }

  &.link {
    display: flex;
    justify-content: center;
    margin-top: 10px;

    a {
      color: #3676CB;
      text-decoration: none;
    }

    &:hover {
      background: rgba(0, 0, 0, 0);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Users/company/VolumesWorksJob.vue